const getComponentName = async(target, level = target.matched.length - 1) => {
  let componentName
  const component = target.matched[level].components.default

  if (typeof component === 'function') {
    const res = await component()
    componentName = res.default ? res.default.name : res.name
  } else {
    componentName = component.name
  }

  if (!componentName) {
    console.warn('当前组件没有设置组件名：', target)
  }

  return componentName
}

// 处理路由缓存
export const dealCache = async(to, from, next, store) => {
  const handleCache = async(route, isAdd) => {
    const [lastComponentName, fastComponentName] = await Promise.all([
      getComponentName(route),
      getComponentName(route, 0)
    ])

    if (lastComponentName) {
      if (isAdd) {
        store.commit('keepAlive/add', lastComponentName)
      } else {
        store.commit('keepAlive/remove', lastComponentName)
      }
    }

    if (fastComponentName) {
      if (isAdd) {
        store.commit('keepAlive/add', fastComponentName)
      } else {
        store.commit('keepAlive/remove', fastComponentName)
      }
    }
  }

  if (to.meta.cache) {
    await handleCache(to, true)
  }

  if (from.meta.cache) {
    /**
     * 使用to.name 不使用 组件name 的原因：
     * 组件可能会被复用，一个组件多个路由，使用组件名会导致，跳转路由是本意无需缓存，但匹配到组件名所以是缓存了
     */
    const shouldCache = !from.meta.cache.includes(to.name)
    await handleCache(from, !shouldCache)
  }
}
